module.exports = __webpack_public_path__ + "static/media/PreferredMark.f61d6b1c.svg";